import script from "./LeaveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeaveModal.vue?vue&type=script&setup=true&lang=ts"

import "./LeaveModal.vue?vue&type=style&index=0&id=1880d73b&scoped=true&lang=css"
import "./LeaveModal.vue?vue&type=style&index=1&id=1880d73b&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1880d73b"]])

export default __exports__